<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
  				<el-form :inline="true">
	  				<el-form-item>
						<el-input placeholder="请输入内容" v-model="inputWhat" class="input-with-select" size="mini">
						    <el-select v-model="selectWhat" slot="prepend" placeholder="请选择">
							    <el-option label="设备ID" value="1"></el-option>
							    <el-option label="MAC地址" value="2"></el-option>
						    </el-select>
					    <el-button slot="append" icon="el-icon-search" @click="Andsearch">搜索</el-button>
					  </el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" plain size="mini" @click="cleardidmac">← 清除</el-button>
					</el-form-item>
					<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新页面</el-button>
				</el-form-item>
				</el-form>
				<el-form :inline="true">
				<el-form-item>
					<el-select v-model="selectMore" placeholder="筛选项" size="mini" style="width: 200px;">
	  					<el-option v-for="item in Choice" :label='item.name' :key='item.val' :value='item.val'></el-option>
					</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">范围：</el-button>
				</el-form-item>
  				<el-form-item>
					<el-input type="number" v-model="input1" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="color: #000;cursor: auto;">~</el-button>
				</el-form-item>
				<el-form-item>
					<el-input  type="number" v-model="input2" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" plain size="mini" @click="handleInputConfirm">添加条件 ↓</el-button>
				</el-form-item>
			</el-form>
			<el-form :inline="true" id="addMessage">
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">筛选条件:</el-button>
				</el-form-item>
				<el-form-item>
					<div id="Addbox">
						<el-tag type="success" :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)" style="margin-right: 10px;" size="small">{{tag}}</el-tag>
					</div>
				</el-form-item>	
				<el-form-item>
					<el-button type="primary" plain size="mini" @click="Quickfind">搜索</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight" header-align="right" @filter-change="Filterfind">
			<!--<el-table-column label="任务单号" prop="sid" :formatter="dataForm" width="90"></el-table-column>-->
		    <!--<el-table-column label="内部ID" prop="sid" width="125"></el-table-column>-->
		    <el-table-column fixed label="序号" width="50" prop="sNumber"></el-table-column>
		    <el-table-column label="设备ID" fixed prop="did" width="195"></el-table-column>
		    <el-table-column label="Mac" prop="mac" width="130"></el-table-column>
<!--		    <el-table-column label="出货时间" prop="delivery_date" :formatter="dateFormat2" width="100"></el-table-column>-->
		    <el-table-column label="发货地址" prop="address" width="300" :formatter="addformat"></el-table-column>
		    <el-table-column label="设备类别" prop="type" width="120"></el-table-column>
<!--		    <el-table-column label="经销商" prop="dealer" width="300" column-key="dealer" :filters='DealerFilt'></el-table-column>-->
		    <el-table-column label="颜色" prop="color" width="70" column-key="color_code" :filters='ColorFilt'></el-table-column>
		    <el-table-column label="版本" prop="edition" width="60"></el-table-column>
		    <el-table-column label="故障状态" prop="is_err" width="100" column-key="is_err" :filters="StateFilt">
		    	<template slot-scope="scope">
		    		<span v-if="scope.row.is_err">错误</span>
		    		<span v-if="!scope.row.is_err">正常</span>
		    	</template>
		    </el-table-column>
		    <!--<el-table-column label="站立时长" column-key="stance_time">
		    	<template slot-scope="scope">
		    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.stance_time}}</el-button>
		    	</template>
		    </el-table-column>-->
		    <el-table-column label="开机时长" column-key="running_time">
		    	<template slot-scope="scope">
		    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{timeformat(scope.row.running_time)}}</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column label="行驶里程" column-key="distance">
		    	<template slot-scope="scope">
		    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.distance}}</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column label="限速次数(次)" column-key="speed_limit_times">
		    	<template slot-scope="scope">
		    		{{scope.row.speed_limit_times}}
		    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.speed_limit_times}}</el-button>-->
		    	</template>
		    </el-table-column>
		    <el-table-column label="推行次数(次)" column-key="push_times">
		    	<template slot-scope="scope">
		    		{{scope.row.push_times}}
		    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.push_times}}</el-button>-->
		    	</template>
		    </el-table-column>
		    <el-table-column label="锁定次数(次)" column-key="push_times">
		    	<template slot-scope="scope">
		    		{{scope.row.lock_times}}
		    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.lock_times}}</el-button>-->
		    	</template>
		    </el-table-column>
		    <el-table-column label="速度档位时长（分钟）">
		    	<el-table-column label="1档">
		    		<template slot-scope="scope">
		    			{{timeformat(scope.row.speed_stage.gear_1st)}}
			    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.speed_stage.gear_1st}}</el-button>-->
			    	</template>
		    	</el-table-column>
				<el-table-column label="2档">
					<template slot-scope="scope">
						{{timeformat(scope.row.speed_stage.gear_2nd)}}
			    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.speed_stage.gear_2nd}}</el-button>-->
			    	</template>
				</el-table-column>
				<el-table-column label="3档">
					<template slot-scope="scope">
						{{timeformat(scope.row.speed_stage.gear_3rd)}}
			    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row)">{{scope.row.speed_stage.gear_3rd}}</el-button>-->
			    	</template>
				</el-table-column>
		    </el-table-column>
		    <el-table-column label="摆臂状态" >
		    	<el-table-column label="摆下" >
		    		<template slot-scope="scope">
		    			{{timeformat(scope.row.swing_arm.angled)}}
			    	</template>
		    	</el-table-column>
				<el-table-column label="直立">
					<template slot-scope="scope">
						{{timeformat(scope.row.swing_arm.upRight)}}
			    	</template>
				</el-table-column>
				<el-table-column label="摆臂切换次数(次)" column-key="swing_arm_usage" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.swing_arm.motor}}</el-button>
			    	</template>
				</el-table-column>
		    </el-table-column>
		    <el-table-column label="座椅位置">
		    	<el-table-column label="伸出">
		    		<template slot-scope="scope">
		    			{{scope.row.seat.stretch}}
			    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.seat.stretch}}</el-button>-->
			    	</template>
		    	</el-table-column>
				<el-table-column label="收回">
					<template slot-scope="scope">
						{{scope.row.seat.home}}
			    		<!--<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.seat.home}}</el-button>-->
			    	</template>
				</el-table-column>
				<el-table-column label="电机使用时长" column-key="seat_motor" width="150">
					<template slot-scope="scope">
			    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{timeformat(scope.row.seat.motor)}}</el-button>
			    	</template>
				</el-table-column>
		    </el-table-column>
		    <el-table-column label="左缠绕带时长" column-key="winding_belt_left" width="100">
		    	<template slot-scope="scope">
			    	<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{timeformat(scope.row.winding_belt.left)}}</el-button>
			    </template>
		    </el-table-column>
		    <el-table-column label="右缠绕带时长" column-key="winding_belt_right" width="100">
		    	<template slot-scope="scope">
			    	<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{timeformat(scope.row.winding_belt.right)}}</el-button>
			    </template>
		    </el-table-column>
		    <el-table-column label="各按键使用次数(次)">
		    	<el-table-column v-for="(item,index) in BotListCn" :label='item.cn' :column-key="item.en" :key="item.index">
		    		<template slot-scope="scope">
			    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.bottom[index]}}</el-button>
			    	</template>
		    	</el-table-column>
		    	<el-table-column label="软开关次数(次)" column-key="switch_usage">
		    	<template slot-scope="scope">
		    		<el-button type="text" @click="LookDetail(scope.$index,scope.row,scope.column)">{{scope.row.switch_usage}}</el-button>
		    	</template>
		    	</el-table-column>
		    </el-table-column>
		    <el-table-column v-for="(item,index) in errList" :label="item.cn" :column-key="item.en" :key="item.index">
		    	<template slot-scope="scope">
		    		<el-button type="text" @click="LookLose(scope.$index,scope.row,scope.column)">{{scope.row.errors[index]}}</el-button>
		    	</template>
		    </el-table-column>
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<!--<el-button type="primary" size="small" @click="ShowDeleted">显示已删除设备</el-button>-->
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<el-dialog title="设备详情" :visible.sync="DetailVisible" width="90%" top="5%" :before-close="closeEqu">
			<div id="DetailBox"></div>
		</el-dialog>
		
		<el-dialog :title="loseTitle" :visible.sync="LoseVisible" id="Losedia" :fullscreen="true">
			<div style="display: flex;">
				<el-table border :data="loseOne" v-loading="loseloading">
	      			<el-table-column label="序号" prop="id" width="80">\</el-table-column>
	      			<el-table-column label="丢失时间" prop="e_time" :formatter="dateFormat">\</el-table-column>
	    		</el-table>
	    		<el-table border :data="loseTwo" v-loading="loseloading">
	      			<el-table-column label="序号" prop="id" width="80">\</el-table-column>
	      			<el-table-column label="丢失时间" prop="e_time" :formatter="dateFormat">\</el-table-column>
	    		</el-table>
			</div>
			
    		
    		<el-col :span="24" class="toolbar">
				<el-pagination layout="prev, pager, next" @current-change="LoseCurrentChange" :page-size="LosePagesize" :current-page="LoseCurpage" :total="Losetotal" style="float:right;">
				</el-pagination>
			</el-col>
		</el-dialog>
		
	</div>
</template>

<script>
	import echarts from 'echarts'
	import moment from 'moment'
	import {GetDealerlist,GetBetweenlist,GetDevDetail,GetErrlist} from '../api/api';
	
	export default {
		data(){
			return{
				loseTitle:"",
				maxHeight:500,
				loseData:[],
				LoseVisible:false,
				loseloading:false,
				LosePagesize:40,
				LoseCurpage:1,
				Losetotal:1,
				loseOne:[],
				loseTwo:[],
				loseThr:[],
				loseFou:[],
				Form:{
					mac:""
				},
				thmac:"",
				thtype:"",
				StandMix:"",
				StandMax:"",
				token:"",
				Limits:"",
				inputWhat:"",
				selectWhat:"",
				inputMore:"",
				selectMore:"",
				input1:"",
				input2:"",
				List:[],
				listloading:false,
				Pagesize:20,
				Curpage:1,
				total:1,
				Color:"",
				State:"",
				Dealer:"",
				Dealerlist:[],
				Screenall:{},
				Betweenall:{},
				DetailVisible:false,
				charts:"",
				Seric:[],
				lastAll:{},
				dynamicTags:[],
				betweenData:{},
				Choice:[
					{name:"站立时长",val:1,oten:"time_of_standing"},
					{name:"限速次数",val:2,oten:"speed_limit_times"},
					{name:"推行次数",val:3,oten:"push_times"},
					{name:"锁定次数",val:4,oten:"lock_times"},
					{name:"1档时长",val:5,oten:"speed_stage.1st_gear"},
					{name:"2档时长",val:6,oten:"speed_stage.2nd_gear"},
					{name:"3档时长",val:7,oten:"speed_stage.3rd_gear"},
					{name:"摆臂摆下",val:8,oten:"swing_arm.angled"},
					{name:"摆臂直立",val:9,oten:"swing_arm.upRight"},
					{name:"座椅伸出",val:10,oten:"seat.stretch"},
					{name:"座椅收回",val:11,oten:"seat.home"},
					{name:"左缠绕带时 长",val:12,oten:"winding_belt.left"},
					{name:"右缠绕带时长",val:13,oten:"winding_belt.right"},
				],
				LegendData:['邮件营销','联盟广告','视频广告','直接访问','搜索引擎'],
				XData:[],
				ColorFilt:[{text:'黑金',value:'1'},{text:'白红',value:'2'},{text:'白灰',value:'3'},{text:'钢铁侠',value:'6'},{text:'酒红',value:'7'},{text:'纯黑',value:'8'},{text:'鸟蓝',value:'9'},{text:'粉白',value:'10'}],
				StateFilt:[{text:'正常',value:'0'},{text:'异常',value:'1'}],
				DealerFilt:[],
				firstTimeData:[],
				Tres:{},
				firstClickData:[],
				Xmonth:[],
				danwei:"",
				errList:[
					{
						cn:"镇江驱动器丢失(次)",
						en:'1'
					},
					{
						cn:"can驱动器丢失(次)",
						en:'2'
					},
					{
						cn:"can下控丢失(次)",
						en:'3'
					},
					{
						cn:"can485丢失(次)",
						en:'4'
					},
					{
						cn:"颠簸提醒(次)",
						en:'5'
					},
					{
						cn:"倾斜提醒(次)",
						en:'6'
					},
					{
						cn:"急转提醒(次)",
						en:'7'
					},
					{
						cn:"久站提醒(次)",
						en:'8'
					}
				],
				BotListCn:[
					{
						en:"b_winding_belt_left_loosen",
						cn:"左缠绕电机放松键"
					},
					{
						en:"b_winding_belt_left_tighten",
						cn:"左缠绕电机收紧键"
					},
					{
						en:"b_winding_belt_right_loosen",
						cn:"右缠绕电机放松键"
					},
					{
						en:"b_winding_belt_right_tighten",
						cn:"右缠绕电机收紧键"
					},
					{
						en:"b_seat_stretch",
						cn:"座椅升起键"
					},
					{
						en:"b_seat_home",
						cn:"座椅收回键"
					},
					{
						en:"b_speed_gear_acceleration",
						cn:"加速档位键"
					},
					{
						en:"b_speed_gear_deceleration",
						cn:"减速档位键"
					},
					{
						en:"b_light",
						cn:"灯开关键"
					},
					{
						en:"b_lock",
						cn:"锁定键"
					},
					{
						en:"b_speaker",
						cn:"喇叭键"
					}
				],
				nameList:[
					{
						en:"running_time",
						cn:"开机时长"
					},
					{
						en:"distance",
						cn:"行驶里程"
					},
					{
						en:"swing_arm_usage",
						cn:"摆臂切换次数"
					},
					{
						en:"winding_belt_left",
						cn:"左缠绕带时长"
					},
					{
						en:"winding_belt_right",
						cn:"右缠绕带时长"
					},
					{
						en:"seat_motor",
						cn:"座椅电机"
					},
					{
						en:"switch_usage",
						cn:"开关次数"
					},
					{
						en:"b_winding_belt_left_loosen",
						cn:"左缠绕电机放松键"
					},
					{
						en:"b_winding_belt_left_tighten",
						cn:"左缠绕电机收紧键"
					},
					{
						en:"b_winding_belt_right_loosen",
						cn:"右缠绕电机放松键"
					},
					{
						en:"b_winding_belt_right_tighten",
						cn:"右缠绕电机收紧键"
					},
					{
						en:"b_seat_stretch",
						cn:"座椅升起键"
					},
					{
						en:"b_seat_home",
						cn:"座椅收回键"
					},
					{
						en:"b_speed_gear_acceleration",
						cn:"加速档位键"
					},
					{
						en:"b_speed_gear_deceleration",
						cn:"减速档位键"
					},
					{
						en:"b_light",
						cn:"灯开关键"
					},
					{
						en:"b_lock",
						cn:"锁定键"
					},
					{
						en:"b_speaker",
						cn:"喇叭键"
					}
				],
				barname:""
			}
		},
		methods:{
			timeformat(val){
				var mint = Math.round(val/60)%60
				var hour = (Math.round(val/60) - Math.round(val/60)%60)/60
				if(mint == 0 && hour == 0){
					return 0 + "分钟"
				}else if(hour == 0){
					return mint + "分钟"
				}else if(mint == 0 ){
					return hour + "小时"
				}else{
					return hour + "小时" + mint + "分钟"
				}
			},
			cleardidmac(){
				this.inputWhat = ""
				this.selectWhat = ""
				this.lastAll.did = ""
				this.lastAll.mac = ""
				this.Quickfind()
			},
			Andsearch(){
				if(this.selectWhat ==1){
					this.lastAll.did = "~" + this.inputWhat
					this.lastAll.mac = ""
				}
				if(this.selectWhat ==2){
					this.lastAll.mac = "~" + this.inputWhat
					this.lastAll.did = ""
				}
				this.Quickfind()
			},
			handleInputConfirm() {
				var that = this
				var selectedText = ""
				if(that.selectMore && that.input1 && that.input2){
					for(var i=0;i<this.Choice.length;i++){
						if(this.Choice[i].val == this.selectMore){
							selectedText = this.Choice[i].name
							that.betweenData[this.Choice[i].oten] = [parseInt(that.input1),parseInt(that.input2)]
						}
					}
			        let inputValue = selectedText + ":" + this.input1 +"至"+ this.input2;
			        if (inputValue) {
			          this.dynamicTags.push(inputValue);
			        }
			        this.selectMore = ""
			        this.input1 = ""
			        this.input2 = ""
				}else{
					this.$message.error("请将筛选条件填写完整。")
				}
		   	},
		   	handleClose(tag){
		   		var that = this
		   		for(var i=0;i<this.Choice.length;i++){
		   			if(tag.indexOf(this.Choice[i].name) >= 0){
		   				delete that.betweenData[this.Choice[i].oten]
		   			}
		   		}
		   		this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		   		if(JSON.stringify(that.betweenData) == '{}'){
		   			this.Quickfind()
		   		}
		   	},
			Filterfind(filters){
				var that = this
				for(var item in filters){
					if(filters[item]){
						that.lastAll[item] = filters[item]
					}
				}
				console.log(that.lastAll)
				this.Quickfind()
			},
			Quickfind(){
				var that = this
					that.Screenall = {}
					for(var i in that.lastAll){
						if(that.lastAll[i] && that.lastAll[i].length > 0){
							that.Screenall[i] = that.lastAll[i]
							}
					}
					
					console.log("Screenall",JSON.stringify(that.Screenall))
					var q1 = JSON.stringify([{"AND":this.Screenall}])
					
					that.Betweenall = {}
					for(var i in that.betweenData){
						if(that.betweenData[i] && that.betweenData[i].length > 0){
							that.Betweenall[i] = that.betweenData[i]
							}
					}
					console.log("Betweenall",JSON.stringify(that.Betweenall))
					var q2 = JSON.stringify([{"BETWEEN":this.Betweenall}])
				if(JSON.stringify(that.Screenall) != '{}'){
					this.GetList(GetBetweenlist,{page:this.Curpage,token:this.token,q:q1})
				}else if(JSON.stringify(that.Betweenall) != '{}'){
					this.Getbetween({page:this.Curpage,token:this.token,fields:"device",expand:"device",q:q2})
				}else{
					this.GetList(GetBetweenlist,{page:this.Curpage,token:this.token})
				}
				
			},
			Getbetween(para){
				this.listloading = true
				GetBetweenlist(para).then(res => {
					this.List = []
					for(var i=0;i<res.data.items.length;i++){
						this.List.push(res.data.items[i].device)
					}
					this.Pagesize = res.data.meta.perPage
					this.total = res.data.meta.totalCount
					this.listloading = false
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.List = []
					this.listloading = false
				})
			},
			Refresh(){
				location.reload();
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Quickfind()
			},
			dataForm(row,column){
				var data = row[column.property]
				if (data == undefined) {
				   		return ""
				    } 
				data = data.slice(2,9)
				return data 
			},
			ShowDeleted(){
				
			},
			LookDetail(index,row,column){
				var that = this
				
				var which = Object.assign({}, row);
//				获取mac
				var Wmac = which.mac
//				获取当前列名称
//				var It = column.columnKey
				that.It = column.columnKey
				if(that.It == "running_time" || that.It == "seat_motor" || that.It == "winding_belt_left" || that.It == "winding_belt_right"){
					that.danwei = "（分钟）"
				}else if(that.It == "distance"){
					that.danwei = "(米)"
				}else {
					that.danwei = "（次数）"
				}
//				console.log(which.mac)
//				console.log(column.columnKey)
//				获取今天0:00到30天前的0:00
				var todayYear=(new Date()).getFullYear();
                var todayMonth=(new Date()).getMonth();
                var todayDay=(new Date()).getDate();
                var todayTime=(new Date(todayYear,todayMonth,todayDay)).getTime();//毫秒
                var date1 = todayTime
				var date2 = new Date(date1);
				date2.setDate(date2.getDate() - 29);
				var date3 = Math.floor(new Date().getTime()/1000)
				var date4 = date2.getTime()/1000
//				结束获取时间

//				获取前30天日期(X轴坐标)
				var xdata = []
				for(var i=0;i<30;i++){
					var date5 = new Date(date1);
					date5.setDate(date5.getDate() - i);
					var date6 = moment(date5).format("MM/DD")
					xdata.push(date6)
				}
				xdata.reverse()
				that.Xmonth = xdata
				that.XData = xdata
				this.DetailVisible = true
//				请求接口
				this.getDetail(that.It,date4,date3,Wmac)
			},
			getDetail(it,d2,d1,mac){
				var that = this
				var condit = [{"AND":{"mac":mac}},{"BETWEEN":{"date":[d2,d1]}}]
				var condit2 = JSON.stringify(condit)
				let para = {
					token:that.token,
					perPage:30,
					fields:"date,"+it,
					q:condit2
				}
//				console.log("para",para)
				var val = []
				GetDevDetail(para).then(res => {
					console.log("res",res)
					that.Tres = res
					var getdata = res.data.items
					for(var i = 0;i<getdata.length;i++){
//						console.log(getdata[i])
						var all = 0
						for(var j=0;j<getdata[i][it].length;j++){
							all += getdata[i][it][j]
						}
						val.push(all)
					}
//					console.log("val",val)
					var lastdata = []
					for(var i=0;i<val.length;i++){
						lastdata[i] = {}
						lastdata[i].time = getdata[i].date
						lastdata[i].value = val[i]
					}
					for(var item in lastdata){
						var datelast = lastdata[item].time*1000
						lastdata[item].time = moment(lastdata[item].time*1000).format("MM/DD")
					}
//					console.log("lastdata2",lastdata)
					var lastestData = []
					for(var i=0;i<that.XData.length;i++){
						lastestData[i] = 0
						for(var j=0;j<lastdata.length;j++){
							if(lastdata[j].time == that.XData[i]){
								lastestData[i] = lastdata[j].value
//								console.log(lastestData[i])
							}
						}
					}
//					console.log("lastestData",lastestData)
					that.firstTimeData = lastestData
					
					for(var i=0;i<that.nameList.length;i++){
						if(that.nameList[i].en == that.It){
							that.barname = that.nameList[i].cn
						}
					}
					
					that.Seric = [
						{
				            name:that.barname,
				            type:'bar',
				            barWidth: '40%',
							data:that.firstTimeData
				        }
					]
				
					this.$nextTick(function() {
		                this.DrawPie()
		            })
					
				}).catch(err => {
					this.$message.error(err.response.data.message)
				})
			},
			closeEqu(){
				this.Seric = []
				this.charts.dispose()
				this.DetailVisible = false
			},
			GetDealerFilt(){
				var that = this
				let param = {
					perPage:1000,
					token:that.token,
					fields:"id,name",
				}
				GetDealerlist(param).then(res => {
					console.log(res)
					that.Dealerlist = res.data.items
					for(var i=0;i<that.Dealerlist.length;i++){
						this.DealerFilt = this.Dealerlist
						this.DealerFilt[i].text = this.Dealerlist[i].name
						this.DealerFilt[i].value = this.Dealerlist[i].name
						delete this.DealerFilt[i].name
//						this.DealerFilt[i].value = this.Dealerlist[i].name
//						delete this.DealerFilt[i].id
					}
				}).catch(err => {
					that.$message.error(err.response.data.message)
				})
			},
			DrawPie(){
				var that = this
				that.charts = echarts.init(document.getElementById('DetailBox'))
				that.opt(true)
				that.click1()
			},
			click1(){
				var that = this
				var nameArr = ['0:00','1:00','2:00','3:00','4:00','5:00','6:00','7:00','8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00']
				that.charts.on('click', function (params) {
					console.log("params",params)
				    console.log('你点击的是: ' + params.seriesName);
				    console.log("olddata赋值前",that.Tres.data.items)
				    var olddata = that.Tres.data.items
				    console.log("olddata格式化未完成",olddata)
				    for(var i=0;i<olddata.length;i++){
				    	if(olddata[i].date > 1000){
				    		olddata[i].date = moment(olddata[i].date*1000).format("MM/DD")
				    	}
				    }
				    for(var m=0;m<olddata.length;m++){
				    	if(olddata[m].date == params.name){
				    		that.firstClickData = olddata[m][that.It]
				    	}
				    }
				    console.log("olddata格式化完成",olddata)
				    that.Seric = []
					that.charts.dispose()
					that.charts = echarts.init(document.getElementById('DetailBox'))
					
					that.XData = nameArr
					that.Seric = [
						{
				            name: params.name,
				            type: 'bar',
				            barWidth: '40%',
							data:that.firstClickData
				        }
					]
				    that.opt(true)
				    that.click2()
				});
			},
			click2(){
				var that = this
				that.charts.on('click', function (params) {
					console.log(params)
				    console.log('你点击的是: ' + params.seriesName);
				    console.log("click2",that.firstTimeData)
				    that.Seric = []
					that.charts.dispose()
					that.charts = echarts.init(document.getElementById('DetailBox'))
					that.XData = that.Xmonth
					that.Seric = [
						{
				            name:that.barname,
				            type:'bar',
				            barWidth: '60%',
				            data:that.firstTimeData
				        }
					]
					that.opt(true)
					that.click1()
				});
			},
			opt(a){
				var that = this
				that.charts.setOption({
					color: ['#3398DB'],
					title: {
				        left: 'center',
				        text: that.barname,
				    },
					tooltip : {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'shadow',
				        }
				    },
				    toolbox: {
				        feature: {
				            saveAsImage: {},
				             magicType: {
						        type: ['line', 'bar']
						    }
				        }
				    },
				    grid: {
				        left: '3%',
				        right: '4%',
				        bottom: '3%',
				        containLabel: true
				    },
				    xAxis : [
				        {
				            type : 'category',
				            data : that.XData,
				            axisTick: {
				                alignWithLabel: a
				            }
				        }
				    ],
				    yAxis : [
				        {
				            type : 'value',
				            name:that.danwei
				        }
				    ],
				    series:that.Seric
				})
			},
			addformat(row,column){
				var add = row[column.property]
				if(add){
					if(add[0] == "无"){
						return "无"
					}else if(add[0] == add[1]){
						return add[1] + add[2] + add[3]
					}else{
						return add[0] + add[1] + add[2] + add[3]
					}
				}else{
					return "无"
				}
			},
			LoseCurrentChange(val){
				var that = this
				that.LoseCurpage = val
				that.getloselist()
			},
			getloselist(){
				var that = this
				let para = {
					token:that.token,
					page:that.LoseCurpage,
					perPage:that.LosePagesize,
					q:JSON.stringify([{"AND":{'mac':that.thmac,'e_type':that.thtype}}])
				}
				that.loseloading = true
				
				GetErrlist(para).then(res => {
					if(res.status == "200"){
//						console.log("loseData",res.data.items)
						that.loseloading = false
						that.loseData = res.data.items
						that.Losetotal = res.data.meta.totalCount
						for(var i=0;i<that.loseData.length;i++){
							that.loseData[i].id = that.Losetotal - (that.LoseCurpage - 1)*40 - i
						}
						
						var arr = []
						for(var i=0;i<20;i++){
							if(that.loseData[i]){
								arr[i] = that.loseData[i]
							}
						}
						that.loseOne = arr
						
						var arr2 = []
						for(var i=20;i<40;i++){
							if(that.loseData[i]){
								arr2[i-20] = that.loseData[i]
							}
						}
						that.loseTwo = arr2
					}else{
						this.$message.error("对不起，请求失败。")
						that.loseloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					that.loseloading = false
				})
			},
			LookLose(index,row,column){
				var that = this
				that.LoseVisible = true
				var tit
				for(var i=0;i<that.errList.length;i++){
					if(that.errList[i].en == column.columnKey){
						tit = that.errList[i].cn
					}
				}
				that.loseTitle = tit
				
				that.Form = Object.assign({}, row)
				that.thmac = that.Form.mac
				that.thtype = parseInt(column.columnKey)
				that.getloselist()

			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetDealerFilt()
			this.GetList(GetBetweenlist,{page:this.Curpage,token:this.token})
//			this.GetDealerList(GetDealerlist)
		},
		beforeMount(){
			
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		},
	}

</script>

<style scoped>
.el-select{
		width: 100px;
	}
#DetailBox {
	width: 100%;
	height: 600px;
}
#inp .el-input__inner {
	padding: 0;
}
#losedia [class*=el-col-] {
	float: none;
}
</style>


// WEBPACK FOOTER //
// EquipmentInformation.vue?25b041b0